import React from "react";
import { useEffect } from "react";
import $ from "jquery";
import Cta from "../../Shared/Cta";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import Input from "../../Shared/CustomInput";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomSelect from "../../Shared/CustomSelect";
import CustomInput from "../../Shared/CustomInput";
import { classOptions, codeOption, subjectOptions } from "../../utils/helpers";
import SubmitForm from "../../Shared/SubmitForm";

const Subject = () => {
  useEffect(() => {
    $(".checkAll").on("click", function () {
      $(this)
        .parents(".table")
        .find("input:checkbox")
        .prop("checked", this.checked);
    });
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("submitting data ", data);
  };

  return (
    <>
      <div class="breadcrumbs-area">
        <h3>All Subjects</h3>
        <ul>
          <li>
            <Link to="/admin">Home</Link>
          </li>
          <li>Subjects</li>
        </ul>
      </div>

      <div class="row">
        <div class="col-4-xxxl col-12">
          <div class="card height-auto">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>Add New Subject</h3>
                </div>
                <Cta />
              </div>
              <form class="new-added-form" onSubmit={handleSubmit(onSubmit)}>
                <div class="row">
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomInput
                      label={"Subject Name *"}
                      register={register}
                      errors={errors}
                      name={"subjectname"}
                    />
                  </div>
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Subject Type *"}
                      register={register}
                      errors={errors}
                      name={"subject"}
                      placeholder={"Select Subject"}
                      option={subjectOptions}
                    />
                  </div>
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Subject Class *"}
                      register={register}
                      errors={errors}
                      name={"subject"}
                      placeholder={"Select Subject"}
                      option={classOptions}
                    />
                  </div>
                  <div class="col-12-xxxl col-lg-6 col-12 form-group">
                    <CustomSelect
                      label={"Subject Code *"}
                      register={register}
                      errors={errors}
                      name={"subject"}
                      placeholder={"Select Subject"}
                      option={codeOption}
                    />
                  </div>
                  <SubmitForm />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-8-xxxl col-12">
          <div class="card height-auto">
            <div class="card-body">
              <div class="heading-layout1">
                <div class="item-title">
                  <h3>All Subjects</h3>
                </div>
                <Cta />
              </div>
              <form class="mg-b-20">
                <div class="row gutters-8">
                  <div class="col-lg-4 col-12 form-group">
                    <input
                      type="text"
                      placeholder="Search by Exam ..."
                      class="form-control"
                    />
                  </div>
                  <div class="col-lg-3 col-12 form-group">
                    <input
                      type="text"
                      placeholder="Search by Subject ..."
                      class="form-control"
                    />
                  </div>
                  <div class="col-lg-3 col-12 form-group">
                    <input
                      type="text"
                      placeholder="dd/mm/yyyy"
                      class="form-control"
                    />
                  </div>
                  <div class="col-lg-2 col-12 form-group">
                    <button
                      type="submit"
                      class="fw-btn-fill btn-gradient-yellow"
                    >
                      SEARCH
                    </button>
                  </div>
                </div>
              </form>
              <div class="table-responsive">
                <table class="table display data-table text-nowrap">
                  <thead>
                    <tr>
                      <th>
                        <div class="form-check">
                          <input
                            type="checkbox"
                            class="form-check-input checkAll"
                          />
                          <label class="form-check-label">ID</label>
                        </div>
                      </th>
                      <th>Subject Name</th>
                      <th>Subject Type</th>
                      <th>Class</th>
                      <th>Date</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">#0021</label>
                        </div>
                      </td>
                      <td>Accounting</td>
                      <td>Mathematics</td>
                      <td>4</td>
                      <td>02/05/2001</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">#0022</label>
                        </div>
                      </td>
                      <td>Bangla</td>
                      <td>Theory</td>
                      <td>6</td>
                      <td>02/05/2001</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">#0023</label>
                        </div>
                      </td>
                      <td>English</td>
                      <td>Theory</td>
                      <td>7</td>
                      <td>02/05/2001</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">#0024</label>
                        </div>
                      </td>
                      <td>Arts</td>
                      <td>Theory</td>
                      <td>6</td>
                      <td>02/05/2001</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">#0025</label>
                        </div>
                      </td>
                      <td>Finanace</td>
                      <td>Theory</td>
                      <td>6</td>
                      <td>02/05/2001</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">#0026</label>
                        </div>
                      </td>
                      <td>Economics</td>
                      <td>Theory</td>
                      <td>6</td>
                      <td>02/05/2001</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">#0027</label>
                        </div>
                      </td>
                      <td>English</td>
                      <td>Theory</td>
                      <td>6</td>
                      <td>02/05/2001</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input" />
                          <label class="form-check-label">#0028</label>
                        </div>
                      </td>
                      <td>Bangla</td>
                      <td>Theory</td>
                      <td>6</td>
                      <td>02/05/2001</td>
                      <td>
                        <Cta />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Subject;
